module.exports = __webpack_public_path__ + "static/media/SFC Btn.39ab5954.png";